import { RemoteBlob } from 'ui/remote-blob';
import styles from './thumbnail.scss';
import * as React from 'react';
import { AttachmentViewer } from 'ui/attachment-viewer/attachment-viewer';
import { UploadedFile } from 'app/area/case/features/file-upload';
import { ComponentProps } from 'ui';

export interface ThumbnailProps extends ComponentProps {
  uploadedFiles?: UploadedFile[];
  loadBlob?: (blobId: number, thumbnail: boolean) => Promise<Blob>;
}

export const getFirstAttachedImage = (uploadedFiles: UploadedFile[]): UploadedFile => {
  const images = uploadedFiles?.filter(i => i?.thumbnailSize > 0);

  if (!images) {
    return null;
  }

  const selectedImage = images.find(i => i.mainImage);
  if (selectedImage) {
    return selectedImage;
  }

  return images[0];
};

export const Thumbnail = (props: ThumbnailProps) => {
  const [viewerOpen, setViewerStatus] = React.useState(false);
  //Print mode should not load the thumbnail blob for better print quality.
  const isPrintMode = new URLSearchParams(window?.location?.search).get('print') === 'true';


  const getBlobFetcher = (blobId: number) => () => {
    return blobId
      ? props.loadBlob(blobId, !isPrintMode) as Promise<Blob>
      : Promise.resolve(undefined)  as Promise<Blob>;
  };

  const files = props.uploadedFiles?.length || 0;
  const firstFile = getFirstAttachedImage(props.uploadedFiles);
  const [thumbnail, setThumbnail] = React.useState(firstFile);
  
  React.useEffect (()=> 
  {
    setThumbnail(firstFile);
  }, [firstFile]);

  if (!files || !firstFile) {
    return null;
  }

  const openViewer = () => {
    setViewerStatus(true);
  };
  const closeViewer = () => {
    setViewerStatus(false);
  };

  return (<>
    {thumbnail?.blobId ? <div id={`${props.componentId}`} className={`${props.className} ${styles.thumbnail}`}>
      <RemoteBlob key={thumbnail.blobId} loadBlob={getBlobFetcher(thumbnail.blobId)}>
        {(remoteBlobProps) => (
          !remoteBlobProps.objectUrl
            ? <div className="image-loading" />
            : <button type="button" className={styles.thumbnailButton} onClick={openViewer}>
                <img src={remoteBlobProps.objectUrl}/>
              </button>
        )}
      </RemoteBlob>
      {viewerOpen && <AttachmentViewer loadBlob={props.loadBlob}
        uploadedFiles={props.uploadedFiles} initialSelected={thumbnail.id} onClose={closeViewer}/> }
    </div> : null}
  </>);
};
